var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M15 5V3H9v2H3v2h18V5zM5 8v12c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8H5zm6 10H9v-6h2v6zm4 0h-2v-6h2v6z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }